/// <amd-module name="VSS/Platform/Components/FPSLink/FPSLink" />
import React = require("react");
import { onClickFPS } from "../../FPS";
import { VssComponent } from "../../Layout";
import { publishEvent } from "../../Telemetry";
import { FPSLinkComponentProps } from "./FPSLink.Props";

/**
 * DEPRECATED, use FPSLink in vss-platform-ui
 */
export class FPSLinkComponent extends VssComponent<FPSLinkComponentProps, {}> {
    public render(): JSX.Element {
        const linkProps = {
            ...this.props,
            onClick: (event: React.MouseEvent<HTMLAnchorElement>) => {
                if (!event.isDefaultPrevented()) {
                    if (this.props.href && this.props.supportsFPS !== false) {
                        onClickFPS(this.context.pageContext, this.props.href, true, event, {
                            telemetrySource: this.props.telemetrySource,
                            telemetryProperties: this.props.telemetryProperties,
                            navigationId: this.props.navigationId
                        });
                    } else if (this.props.telemetrySource) {
                        publishEvent(this.context.pageContext, "WebPlatform", "Link", {
                            ...(this.props.telemetryProperties || {}),
                            source: this.props.telemetrySource
                        });
                    }
                }
            }
        };

        // Remove the props which are not valid anchor properties
        delete linkProps.navigationId;
        delete linkProps.supportsFPS;
        delete linkProps.telemetrySource;
        delete linkProps.telemetryProperties;

        return React.createElement("a", linkProps, this.props.children);
    }
}
